import React, { useEffect, useState } from 'react';
import { VerificationCodeInputLayoutProps } from '../types';
import { ErrorsWrapper } from 'ui-builder';

export default function VerificationCodeInputLayoutWeb(props: VerificationCodeInputLayoutProps) {

  const [code, setCode] = useState(() => {
    return Array.from({ length: props.length }, (_, index) => props.value?.[index] ?? undefined);
  });

  const handleChange = (element: HTMLInputElement, index: number) => {
    if (element.value === '' || element.value.match(/^[0-9]$/)) {
      const newCode = [...code];
      newCode[index] = element.value;


      if (index < props.length - 1 && element.value !== '') {
        const nextElement = document.getElementById(`code-input-${index + 1}`);
        if (nextElement) {
          nextElement.focus();
        }
      }

      setCode(newCode);
    }
  };

  useEffect(() => {

    const value = code.map(item => item ?? '').join('');
    props.onChangeCallback({
      target: {
        value: value ? parseInt(value) : undefined,
      },
    });
  }, [JSON.stringify(code)]);

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    const pastedData = event.clipboardData.getData('Text').slice(0, props.length).split('');
    if (pastedData.length === props.length) {
      setCode(pastedData);
    }
  };


  return (
    <ErrorsWrapper errors={props.errors} name={props.name}>
      <div onPaste={handlePaste} style={{ display: 'flex', gap: '8px' }}>
        {Array.from({ length: props.length }, (_, index) => (
          <input
            key={index}
            id={`code-input-${index}`}
            type="text"
            maxLength={1}
            value={code[index]}
            onChange={(e) => handleChange(e.target, index)}
            onFocus={(e) => e.target.select()}
            style={{ width: '40px', height: '40px', textAlign: 'center', fontSize: '20px', padding: 0, borderRadius: 0 }}
          />
        ))}
      </div>
    </ErrorsWrapper>
  );
} 